import Vue from 'vue'

const defaultOptions = {
          loop: false,
          responsive: {
            0: {
              items: 1
            },
            480: {
              items: 2
            },
            768: {
              items: 3
            },
            992: {
              items: 4
            },
            1200: {
              items: 5
            }
          },
          margin: 20,
          nav: true,
          navText: [],
          dots: false,
          autoWidth: false
        }
function createOwlCarousel($el,options){
  $el.owlCarousel(options)
  $el.trigger('refresh.owl.carousel')
}

let OWL_LOADED = undefined

const index = {
  bind(){
    if(!OWL_LOADED){
      import('./owl.carousel.min.css')
      import('./owl.theme.default.min.css')
      OWL_LOADED = import('owl.carousel/dist/owl.carousel.min.js')
    }
  },
  async inserted(target, binding={value:{}}, vnode=null) {
    await OWL_LOADED

    let owl = $(target),
        options = defaultOptions

    window.themejQuery(true, options, binding.value)
    if(typeof owl.owlCarousel !== 'undefined')
    {
      function owlTime(){
        if(owl.length){
          createOwlCarousel(owl,options)
        }else{
          Vue.nextTick(owlTime,0)
        }
      }
      Vue.nextTick(owlTime,0)
    }
    else
    {
      Vue.nextTick(function () {
        index.inserted(target,binding, vnode)
      }, 0)
    }
  },
  async update(target){
    await OWL_LOADED
    let owl = $(target)
    owl.trigger('destroy.owl.carousel')
  },
  async componentUpdated(target, binding={value:{}}, vnode=null, oldVnode=null){
   await OWL_LOADED
    let owl = $(target),
        options = defaultOptions

    window.themejQuery(true, options, binding.value)
    Vue.nextTick(function(){
      createOwlCarousel(owl,options)
    }, 0)
  },
  async unbind(target){
    await OWL_LOADED
    let owl = $(target)
    Vue.nextTick(function(){
      owl.trigger('destroy.owl.carousel')
    })
  }
}

export default index


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/IxPlugin/make-owl/index.js